<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!templateMail">
      <span class="loader"></span>
    </span>
    <div v-if="templateMail" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <template-mail-view-global :templateMail="templateMail" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import TemplateMailViewGlobal from "../partials/TemplateMailViewGlobal.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    TemplateMailViewGlobal,
  },

  mixins: [requestErrorMixin],

  props: {
    templateMailId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      templateMail: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("templateMails/get", this.templateMailId);
        this.templateMail = this.$store.getters["templateMails/templateMail"];
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    editTemplateMail() {
      this.$emit("onEditTemplateMail", this.templateMail);
    },
    deleteTemplateMail() {
      this.$emit("onDeleteTemplateMail", this.templateMail);
    },
  },
};
</script>
